import React from 'react';
import { DarkBackground } from 'scy/Background';
import { Small } from 'scy/text';
import { pill, pillText, pillRemove } from './styles.mod.scss';

export default function FilterSelected({ label, renderRemove }) {
  return (
    <DarkBackground className={pill} tag="span">
      <Small tag="span" className={pillText}>
        {label}
      </Small>
      {!!renderRemove && (
        <Small tag="span" className={pillRemove}>
          {renderRemove()}
        </Small>
      )}
    </DarkBackground>
  );
}
